// extracted by mini-css-extract-plugin
module.exports = {"category":"i_DS","option1":"i_DT","option2":"i_DU","option3":"i_DV","option4":"i_DW","option5":"i_DX"};